(function($){

	$(document).ready(function(){

		$(document).on('click','.custom-pager .custom-page',function(e){
			e.preventDefault();
			$action = $(this).data('action');
			$grid_wrapper = $(this).parents('.custom-action__wrapper')
			$grid = $grid_wrapper.siblings('.archive-grid');
			$grid_pager = $grid.siblings('.custom-action__wrapper');
			$current_page_element = $grid_pager.find('.current-page');

			$paged = $grid.attr('data-paged');
			$cat = $grid.data('category');
			$per_page = $grid.data('perPage');

			$grid_wrapper.addClass('processing');

	      	// ajax call to subcribe the newsletter_email
	      	$.ajax({
		        url : user_vars.ajax_url,
		        type : 'POST',
		        data : {
		          action: 'gazoo_fetch_posts',
		          paged: $paged,
		          cat: $cat,
		          per_page: $per_page,
		          page_action: $action
		        },
		        success : function(response) {
		          
		        	if (!!response.success) {
		          		$grid.html(response.posts_html);
		          		$grid.attr('data-paged', response.paged);
		          		$current_page_element.html(response.paged);

		          		if(response.paged > 1) {
		          			$grid_pager.find('.prev').removeClass('active');
		          		} else {
		          			$grid_pager.find('.prev').addClass('active');
		          		}

		          		if(response.more_posts) {
		          			$grid_pager.find('.next').removeClass('active');
		          		} else {
		          			$grid_pager.find('.next').addClass('active');
		          		}

		          		$('html,body').stop().animate({
                        	scrollTop: $grid.offset().top - 200
                    	}, 'linear');

                    	$grid_wrapper.removeClass('processing');

		          	} else {
		            	showNotice('response.message', 'error', newsletterForm);
		            	$grid_wrapper.removeClass('processing');
		          	}
		        },
		        error : function( error ) {
		        	showNotice('There was an error!', 'error', newsletterForm);
		        	$grid_wrapper.removeClass('processing');
		        }
	      	});
		    
		});

	});
	
})(jQuery);